import { render, staticRenderFns } from "./ContentBlockControls.vue?vue&type=template&id=879c31b6&scoped=true"
import script from "./ContentBlockControls.vue?vue&type=script&lang=js"
export * from "./ContentBlockControls.vue?vue&type=script&lang=js"
import style0 from "./ContentBlockControls.vue?vue&type=style&index=0&id=879c31b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879c31b6",
  null
  
)

export default component.exports